<section class="mx-auto flex min-h-[calc(100vh-4.25rem)] max-w-page items-center justify-center px-4 py-10 sm:px-6 lg:px-8">
  <div class="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-8 shadow-sm sm:p-10">
    <div class="flex flex-col gap-2 text-center">
      <h1 class="text-h4 text-slate-950">My Forms</h1>
      <p class="text-body2 text-slate-500">
        @if (step() === 'email') {
          Sign in to access forms that were shared with you.
        } @else {
          Enter the verification code sent to your email.
        }
      </p>
    </div>

    <div class="mt-8 flex flex-col gap-5">
      @if (step() === 'email') {
        <button
          type="button"
          class="flex w-full items-center justify-center gap-3 rounded-xl border border-neutral-300 bg-white px-4 py-3 text-body2 font-medium text-neutral-900 transition-colors duration-200 hover:bg-neutral-50 active:bg-neutral-100"
          (click)="onGoogleContinue()">
          <app-svg-icon src="assets/icons/social/google.svg" [size]="24" />
          <span>Continue with Google</span>
        </button>

        <div class="flex items-center gap-4">
          <div class="h-px flex-1 bg-neutral-200"></div>
          <span class="text-body3 text-neutral-500">or</span>
          <div class="h-px flex-1 bg-neutral-200"></div>
        </div>

        <form class="flex flex-col gap-5" [signalForm]="accessForm">
          <lib-signal-text-field
            [formField]="accessForm.email"
            label="Email"
            inputType="email"
            placeholder="you@company.com"
            autocomplete="email" />

          <lib-signal-button
            [fullWidth]="true"
            [loading]="startState.loading()"
            (clicked)="onEmailContinue()">
            Continue
          </lib-signal-button>
        </form>
      } @else {
        @if (devOtp()) {
          <p class="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-body3 text-amber-900">
            Dev OTP (until email is configured): <span class="font-semibold">{{ devOtp() }}</span>
          </p>
        }

        <form class="flex flex-col gap-5" [signalForm]="otpForm">
          <lib-signal-text-field
            [formField]="otpForm.otp"
            label="Verification code"
            inputType="text"
            placeholder="6-digit code"
            autocomplete="one-time-code" />

          <lib-signal-button
            [fullWidth]="true"
            [loading]="verifyState.loading()"
            (clicked)="onVerifyOtp()">
            Verify and continue
          </lib-signal-button>

          <lib-signal-button
            appearance="text"
            [fullWidth]="true"
            (clicked)="backToEmail()">
            Use a different email
          </lib-signal-button>
        </form>
      }
    </div>
  </div>
</section>
